import {
  BarChart3,
  Calendar,
  CreditCard,
  FileText,
  Home,
  Mail,
  Settings,
  Stethoscope,
  Syringe,
  TestTube,
  Users,
} from "lucide-react";

import { pathGenerators } from "utils/routes";
import { TENANT_TYPES } from "utils/tenantAccess";

// TODO: Restore per-item role restrictions once role permissions are properly configured.
// roles: [] = visible to all roles (quick fix for Niamh/reception, KIN-846).
// tenantTypes: [] (or omitted) = visible to every tenant type. GP sees everything;
// CONSULT hides items not relevant to specialist/consultant practices.
export const MENU_ITEMS = [
  {
    id: "home",
    path: pathGenerators.global.home(),
    label: "Homepage",
    Icon: Home,
    roles: [],
  },
  {
    id: "appointments",
    path: pathGenerators.global.appointments(),
    label: "Appointments",
    Icon: Calendar,
    roles: [],
  },
  {
    id: "patient",
    path: pathGenerators.global.patient(),
    label: "Patients",
    Icon: Users,
    roles: [],
  },
  {
    id: "results",
    path: pathGenerators.global.results(),
    label: "Results",
    Icon: TestTube,
    roles: [],
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    id: "immunisations",
    path: pathGenerators.global.immunizations(),
    label: "Immunisations",
    Icon: Syringe,
    roles: [],
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    id: "documents",
    path: pathGenerators.global.documents(),
    label: "Documents",
    Icon: FileText,
    roles: [],
  },
  {
    id: "communications",
    path: pathGenerators.global.communications(),
    label: "Communications",
    Icon: Mail,
    roles: ["ADMIN", "ROLE_ADMIN"],
  },
  {
    id: "reports",
    path: pathGenerators.global.reports(),
    label: "Reports",
    Icon: BarChart3,
    roles: ["ADMIN", "ROLE_ADMIN", "ROLE_REPORTS"],
  },
  {
    id: "cdm",
    path: pathGenerators.global.cdmFinders({ reportType: "cdm-finder" }),
    label: "CDM Finders",
    Icon: Stethoscope,
    roles: ["ADMIN", "ROLE_ADMIN", "ROLE_REPORTS"],
  },
  {
    id: "payments",
    path: pathGenerators.global.payments(),
    label: "Payments",
    Icon: CreditCard,
    roles: ["ADMIN", "ROLE_ADMIN", "ROLE_PAYMENTS"],
  },
  {
    id: "settings",
    path: pathGenerators.settings.practiceDetails(),
    label: "Settings",
    Icon: Settings,
    roles: ["ADMIN", "ROLE_ADMIN"],
    adminOnly: true,
  },
];
